import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthGate } from '@/components/AuthGate';
import { AppShell } from '@/components/AppShell';
import { TenantProvider } from '@/components/TenantProvider';
import { Conversations } from '@/views/Conversations';
import { ConversationDetail } from '@/views/ConversationDetail';
import { Today } from '@/views/Today';
import { Reports } from '@/views/Reports';
import { Settings } from '@/views/Settings';
import { AuditLog } from '@/views/AuditLog';
import { AdminDiagnostics } from '@/pages/AdminDiagnostics';
import { ClientHealth } from '@/pages/ClientHealth';
import { getLastSlug } from '@/lib/lastSlug';

function RootRedirect() {
  const slug = getLastSlug() ?? 'dp';
  // Today is now the default landing tab per the comms-pivot mock.
  return <Navigate to={`/${slug}/today`} replace />;
}

export default function App() {
  return (
    <AuthGate>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        {/* Operator admin — cross-tenant. No shell, no TenantProvider —
            tenant selection is a dropdown inside the page. */}
        <Route path="/admin/diagnostics" element={<AdminDiagnostics />} />
        <Route
          path="/:slug"
          element={
            <TenantProvider>
              <AppShell />
            </TenantProvider>
          }
        >
          <Route index element={<Navigate to="today" replace />} />
          <Route path="today" element={<Today />} />
          <Route path="conversations" element={<Conversations />} />
          <Route path="conversations/:id" element={<ConversationDetail />} />
          {/* 2026-07-02 (DemoPolish 4) — Leads merged into Chats; the
              pipeline stages are Chats filter chips now. Old links land
              on the full pipeline view (All). */}
          <Route path="leads" element={<Navigate to="../conversations" replace />} />
          <Route path="reports" element={<Reports />} />
          <Route path="settings" element={<Settings />} />
          <Route path="settings/audit-log" element={<AuditLog />} />
          {/* Client owner — single-tenant, outcomes-only. Lives under the
              tenanted shell so it gets the same nav + slug scoping. */}
          <Route path="health" element={<ClientHealth />} />
        </Route>
        <Route path="*" element={<RootRedirect />} />
      </Routes>
    </AuthGate>
  );
}
